import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Packages from './components/Packages';
import AddonPricing from './components/addons/AddonPricing';
import StripeBillingEnabledBanner from './components/StripeBillingEnabledBanner';

const Pricing = () => {
  return (
    <>
      <Box sx={{ width: '100%', overflowX: 'hidden', pb: { xs: 2, sm: 0 } }}>
        <Packages />
        <AddonPricing />
        <StripeBillingEnabledBanner />
      </Box>
      <Outlet />
    </>
  );
};

export default Pricing;
